module.exports = __webpack_public_path__ + "static/media/Construction.1914561f.mp3";